<template>
  <OmtStickedModal v-if="isOpen" @close="$emit('close')">
    <CBox>
      <OmtRow mb="32px">
        <OmtTypography as="h1-bold"> Responder pendências </OmtTypography>
      </OmtRow>

      <CBox v-if="reasons.length">
        <CBox>
          <OmtTypography as="h2-bold">Motivos:</OmtTypography>
          <CBox mt="12px" pl="4">
            <OmtTypography as="p1" v-for="(r, index) in reasons" :key="`r-${index}`">{{ r }}</OmtTypography>
          </CBox>
        </CBox>

        <OmtRow>
          <CDivider mt="32px" mb="32px" />
        </OmtRow>
      </CBox>

      <OmtRow>
        <OmtTypography as="p1" fontWeight="600">
          Insira somente a(s) imagem(ns) e/ou informações solicitadas e relacionadas a este(s) documento(s).
        </OmtTypography>
      </OmtRow>

      <OmtRow mt="16px">
        <ImageUploader @change="onImageUploaderChange" :length="limitFiles" :initialValue="pictures" />
      </OmtRow>

      <OmtRow>
        <OmtTypography as="p3" mb="8px"> <omt-bold>Observações</omt-bold> (opcional)</OmtTypography>
        <CDivider mt="16px" mb="16px" />
      </OmtRow>

      <OmtRow>
        <CFlex flexDirection="column" alignItems="flex-end" mb="32px">
          <OmtTextarea
            class="input-observation"
            height="109px"
            padding="12px"
            placeholder="Inclua informações ou detalhes que podem complementar os documentos enviados."
            @change="handleChange"
            :initialValue="observation"
          />
          <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
            {{ observation.length }}/350
          </OmtTypography>
        </CFlex>
      </OmtRow>
    </CBox>

    <OmtButton w="100%" @click="submit" :disabled="disableButton"> Enviar </OmtButton>
  </OmtStickedModal>
</template>

<script>
import ImageUploader from "@/components/Molecules/ImageUploader";

export default {
  name: "PendingResponseModal",
  components: { ImageUploader },
  props: {
    reasons: {
      Type: Array
    },
    pendencyObservation: {
      Type: String
    },
    isOpen: {
      Type: Boolean
    }
  },
  data() {
    return {
      limitFiles: 20,
      observation: "",
      pictures: []
    };
  },
  computed: {
    disableButton() {
      return !this.observation;
    }
  },
  methods: {
    handleChange(text) {
      this.observation = text;
    },
    onImageUploaderChange(pictures) {
      const result = pictures?.filter(pic => pic.source && pic.name);
      this.pictures = result;
    },
    submit() {
      if (this.disableButton) return;
      this.$emit("submit", { pictures: this.pictures, obs: this.observation });
    }
  }
};
</script>

<style scoped>
.font--semi-bold {
  font-weight: var(--fontWeights-semibold);
}

.list {
  padding-left: 32px;
}
::v-deep .input-observation {
  border: 0.5px solid #dadada;
  color: #8c8c8c !important;
}

::v-deep .input-observation::placeholder {
  color: #8c8c8c !important;
}
</style>
